import { createArea } from 'modal.react.js';

const area = createArea();

export default area;
